module.exports = __webpack_public_path__ + "static/media/thinFilm.434766da.png";